export default __webpack_public_path__ + "static/media/downArrow.e5e6e164.svg";